export const annaWroblewskaCzerniak = {
    'meta': {
        'title': 'Psychoterapeuta psychodynamiczny Anna Wróblewska-Czerniak',
        'description': 'Jestem psychologiem, psychoterapeutą psychodynamicznym i socjoterapeutą. Pracuję z osobami dorosłymi.'
    },
    'url': {
        'address': '/bydgoszcz/zespol/psycholog-psychoterapeuta-anna-wroblewska-czerniak/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/anna-wroblewska-czerniak.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psycholog w Bydgoszczy, Psychoterapeuta w Bydgoszczy Anna Wróblewska-Czerniak'
        }
    }
}